import { render, staticRenderFns } from "./LibraryShelf.vue?vue&type=template&id=33d0dc74&scoped=true&"
import script from "./LibraryShelf.vue?vue&type=script&lang=js&"
export * from "./LibraryShelf.vue?vue&type=script&lang=js&"
import style0 from "./LibraryShelf.vue?vue&type=style&index=0&id=33d0dc74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0dc74",
  null
  
)

export default component.exports